import React, { useEffect, useState } from 'react';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import { useNavigate } from "react-router-dom";
import './Login.css';
import apiService from '../../services/ApiServices';
import logo from '../../img/small.png';

function GoogleLoginPage() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const handleGoogleLoginSuccess = async (tokenResponse) => {
    try {
      setIsLoading(true);
      const accessToken = tokenResponse.credential;
      const response = await apiService.post('/api/auth/login', { token: accessToken });
      console.log('Login successful:', response);

      localStorage.setItem('user', JSON.stringify(response.existingUser));
      localStorage.setItem('AUTH_TOKEN_KEY', response.token);

      // Force redirect after a small delay
      setTimeout(() => {
        navigate('/dashboard');
        window.location.reload(); // Optional: to refresh the app state
      }, 100);

    } catch (error) {
      console.error('Login failed:', error);
      setIsLoading(false);
    }
  };

  const handleGoogleSignupSuccess = async (tokenResponse) => {
    try {
      setIsLoading(true);
      const accessToken = tokenResponse.credential;
      const response = await apiService.post('/api/auth/signup', { token: accessToken });
      console.log('Signup successful:', response);

      localStorage.setItem('user', JSON.stringify(response.newUser));
      localStorage.setItem('AUTH_TOKEN_KEY', response.token);

      // Force redirect
      setTimeout(() => {
        navigate('/dashboard');
        window.location.reload(); // Optional: to refresh the app state
      }, 100);

    } catch (error) {
      console.error('Signup failed:', error);
      setIsLoading(false);
    }
  };

  const handleGoogleLoginFailure = (error) => {
    console.error('Google authentication failed:', error);
    setIsLoading(false);
  };

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    const authToken = localStorage.getItem("AUTH_TOKEN_KEY");

    if (storedUser && authToken) {
      navigate('/dashboard');
    }
  }, [navigate]);

  return (
    <div className="container-fluid min-vh-100 d-flex align-items-center justify-content-center bg-light">
      <div className="row w-100 justify-content-center">
        <div className="col-md-6 col-lg-4">
          <div className="card shadow-lg border-0 rounded-3">
            <div className="card-body p-5">

              {/* Loading Overlay */}
              {isLoading && (
                <div className="loading-overlay position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center bg-light bg-opacity-75 rounded-3">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <span className="ms-2">Redirecting...</span>
                </div>
              )}

              {/* Header */}
              <div className="text-center mb-4">
                <div className="bg-primary rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
                  style={{ width: '60px', height: '60px' }}>
                  <img
                     src={logo}
                    alt="Logo"
                    style={{ width: '40px', height: '40px', objectFit: 'contain' }}
                  />
                </div>
                <h2 className="fw-bold text-dark mb-1">Welcome</h2>
                <p className="text-muted">Choose your authentication method</p>
              </div>

              {/* Login Section */}
              <div className="mb-4">
                <div className="d-flex align-items-center mb-3">
                  <i className="fas fa-sign-in-alt text-primary me-2"></i>
                  <h5 className="mb-0 fw-semibold">Existing User</h5>
                </div>
                <GoogleOAuthProvider clientId="1069600965731-i4gq6oojr22640a80m1uic2jn128jrl7.apps.googleusercontent.com">
                  <div className="d-grid">
                    <GoogleLogin
                      onSuccess={handleGoogleLoginSuccess}
                      onError={handleGoogleLoginFailure}
                      theme="filled_blue"
                      size="large"
                      text="signin_with"
                      width="100%"
                    />
                  </div>
                </GoogleOAuthProvider>
                <div className="text-center mt-2">
                  <small className="text-muted">Sign in with your Google account</small>
                </div>
              </div>

              {/* Divider */}
              <div className="position-relative my-4">
                <hr />
                <div className="position-absolute top-50 start-50 translate-middle px-3 bg-white">
                  <span className="text-muted small">OR</span>
                </div>
              </div>

              {/* Signup Section */}
              <div>
                <div className="d-flex align-items-center mb-3">
                  <i className="fas fa-user-plus text-success me-2"></i>
                  <h5 className="mb-0 fw-semibold">New User</h5>
                </div>
                <GoogleOAuthProvider clientId="1069600965731-i4gq6oojr22640a80m1uic2jn128jrl7.apps.googleusercontent.com">
                  <div className="d-grid">
                    <GoogleLogin
                      onSuccess={handleGoogleSignupSuccess}
                      onError={handleGoogleLoginFailure}
                      theme="outline"
                      size="large"
                      text="signup_with"
                      width="100%"
                    />
                  </div>
                </GoogleOAuthProvider>
                <div className="text-center mt-2">
                  <small className="text-muted">Create a new account with Google</small>
                </div>
              </div>

              {/* Footer Info */}
              <div className="mt-4 pt-3 border-top text-center">
                <small className="text-muted">
                  <i className="fas fa-lock me-1"></i>
                  Your information is securely encrypted
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GoogleLoginPage;


